import { HintToggleButton } from '@paytrace/pt-skel/Component/Button/HintToggleButton'
import React from 'react'

export type HeaderToolbarProps = {
    helpLink: string
    }

export default function HeaderToolbar ({ helpLink }: HeaderToolbarProps) {
  return (
      <div className='float-right'>
        <HintToggleButton />
        <a className='help-link' href={helpLink}>Help</a>
      </div>
  )
}
